import * as React from 'react';
import { Button, ReferenceArrayInput, SelectArrayInput } from 'react-admin';
import { required } from 'react-admin';

const validateRequired = required();

const OpenSpecialtiesButton = ({ action }) => {
  const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    setOpen(true);
  };

  return (
    <>
      <div>
        <Button onClick={handleClick} label="Definir Especialidades" />
      </div>
      {open && (
        <ReferenceArrayInput
          reference="specialties"
          source="specialties.id"
          perPage={999}
          sort={{ field: "name", order: "ASC" }}
        >
          <SelectArrayInput
            validate={action === true ? null  : validateRequired}
            label='Especialidade'
            optionText="name"
            optionValue="id"
          />
        </ReferenceArrayInput>
      )}
    </>
  );
};

export default OpenSpecialtiesButton;
